module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_6_2.58405cd6.jpeg";